module.exports = __webpack_public_path__ + "static/bnr_square@2x-7834cc9a832f18891ef78c7ae45dcf2a.png";